"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResolutionInput = void 0;
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../common/constants");
var _DialogContent = require("../../primitives/DialogContent");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ResolutionInput = function ResolutionInput(_ref) {
  var onResolutionChange = _ref.onResolutionChange,
    disabled = _ref.disabled,
    tooltipText = _ref.tooltipText,
    css = _ref.css,
    testId = _ref.testId;
  var _useState = (0, _react.useState)(_constants.RTMP_RECORD_DEFAULT_RESOLUTION),
    _useState2 = _slicedToArray(_useState, 2),
    resolution = _useState2[0],
    setResolution = _useState2[1];
  var resolutionChangeHandler = (0, _react.useCallback)(function (event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    var width = name === "resWidth" ? Number(value) : resolution.width;
    var height = name === "resHeight" ? Number(value) : resolution.height;
    if (width === 0) {
      width = null;
    }
    if (height === 0) {
      height = null;
    }
    var newResolution = {
      width: !isNaN(width) ? width : _constants.RTMP_RECORD_DEFAULT_RESOLUTION.width,
      height: !isNaN(height) ? height : _constants.RTMP_RECORD_DEFAULT_RESOLUTION.height
    };
    setResolution(newResolution);
  }, [resolution]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.DialogRow, {
    breakSm: true,
    css: css,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      gap: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
        css: {
          mb: "$8"
        },
        children: "Resolution"
      }), tooltipText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
        title: tooltipText,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.InfoIcon, {
            color: "#B0C3DB"
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      justify: "between",
      css: {
        width: !tooltipText ? "100%" : "70%",
        "@sm": {
          width: "100%"
        }
      },
      gap: 2,
      direction: "column",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        justify: "between",
        gap: 2,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          direction: "column",
          css: {
            width: "50%"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "xs",
            children: "Width"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
            "data-testid": "".concat(testId, "_width"),
            css: {
              width: "100%",
              mt: "$4"
            },
            name: "resWidth",
            value: resolution.width,
            onChange: resolutionChangeHandler,
            readOnly: disabled,
            min: _constants.RTMP_RECORD_RESOLUTION_MIN,
            max: _constants.RTMP_RECORD_RESOLUTION_MAX,
            onBlur: function onBlur() {
              return onResolutionChange(resolution);
            },
            type: "number"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          direction: "column",
          css: {
            width: "50%"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "xs",
            children: "Height"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
            "data-testid": "".concat(testId, "_height"),
            css: {
              width: "100%",
              mt: "$4"
            },
            name: "resHeight",
            value: resolution.height,
            onChange: resolutionChangeHandler,
            onBlur: function onBlur() {
              return onResolutionChange(resolution);
            },
            readOnly: disabled,
            min: _constants.RTMP_RECORD_RESOLUTION_MIN,
            max: _constants.RTMP_RECORD_RESOLUTION_MAX,
            type: "number"
          })]
        })]
      })
    })]
  });
};
exports.ResolutionInput = ResolutionInput;